export const ROUTES = {
  DASHBOARD: 'dashboard',
  ADD_BREAK: 'add-break/:id',

  addBreakWithId: (id: string | number) => `add-break/${id}`,
};
